import React, { Component } from 'react';

import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react';

import TicketList from '../components/TicketList';

class TicketsView extends Component {

  render() {
    const { store, history } = this.props;
    if (store.errors.length) {
      history.push('/error');
      return null;
    }
    else if (store.cashsale.get()) {
      history.push('/confirmation');
    }    
    return (
      <span>
          <TicketList />
      </span>
    );
  }

}

export default withRouter(inject('store')(observer(TicketsView)));



// WEBPACK FOOTER //
// ./src/views/TicketsView.js